var _style, _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEhMonogram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "monogram",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400 400",
    style: {
      enableBackground: "new 0 0 400 400"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#CC0000;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "circle",
    className: "st0",
    cx: 200,
    cy: 201,
    r: 200
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "e",
    className: "st1",
    d: "M196.8,0.1C87.8,1.8,0,90.6,0,199.9c0,110.5,89.5,200,200,200c6,0,11.8-0.4,17.7-0.9L196.8,0.1z  M194.5,269.7h-90.3V132.2h83.4v7.5h-75.9v52.5H182v7.5h-70.3v62.5h82.8V269.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "h",
    className: "st1",
    d: "M204.3,0.1l10.1,192h77.9v-64.3h7.5v138h-7.5v-66.2h-77.5l10.4,198.5C323.7,385.8,400,301.8,400,199.9 C400,90.9,312.7,2.4,204.3,0.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEhMonogram);
export default __webpack_public_path__ + "static/media/eh-monogram.4a869323fb0814439e1464be3c8f9b34.svg";
export { ForwardRef as ReactComponent };